export default function CornerMark({ template, accent }) {
  const mark = template.decorativeMark;

  if (mark === 'corner-arc') {
    return (
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '0.85in',
          height: '0.85in',
          background: accent,
          borderBottomLeftRadius: '100%',
          opacity: 0.92,
        }}
      />
    );
  }

  if (mark === 'thin-rule') {
    return (
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: '0.5in',
          right: '0.75in',
          width: '0.75in',
          height: '2px',
          background: accent,
        }}
      />
    );
  }

  return null;
}
